import React from 'react';

/** Visual parity with KMP 3-step signup funnel (OW-181–185). */
const SignupStepBadge: React.FC<{
  step: 1 | 2 | 3;
  isRTL: boolean;
}> = ({ step, isRTL }) => (
  <p className="text-sm text-slate-500 dark:text-slate-400 mb-2">
    {isRTL ? `الخطوة ${step} من 3` : `Step ${step} of 3`}
  </p>
);

export default SignupStepBadge;
